module.exports = __webpack_public_path__ + "img/0.7296b7db.svg";